import axios from 'axios';
import store from 'store';
import { setUserImageSrc } from 'redux/modules/user/index';
import LogotypeEntity from './logotype-entity';
import {APIResult} from '../http';

class LogotypeService {

  hydrate (logotype) {
    return new LogotypeEntity(
      logotype.id,
      logotype.attributes.image_src
    );
  }

  hydrateCollection (data) {
    var logotypes = [];

    for (let logotype of data) {
      logotypes.push(this.hydrate(logotype));
    }

    return logotypes;
  }

  get () {
    return axios.get('backend://logotypes')
      .then(
        (response) => {
          var logotypes = this.hydrateCollection(response.data.data);
          return new APIResult(logotypes, response.data.meta);
        }
      );
  }

  post (params) {
    let data = {
      data: {
        attributes: params
      }
    };
    return axios.request({
      url: 'backend://logotypes',
      method: 'POST',
      data: data
    }).then((response) => {
      const logotype = this.hydrate(response.data.data);
      store.dispatch(setUserImageSrc(logotype.imageSrc));
      return logotype;
    });
  }

  delete (params) {
    let data = {
      data: {
        attributes: params
      }
    };
    return axios.request({
      url: 'backend://logotypes',
      method: 'DELETE',
      data: data
    }).then((response) => {
      store.dispatch(setUserImageSrc(''));
      return response.data;
    });
  }
}

export default new LogotypeService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/logotype/logotype-service.js
 **/